import angular from 'angular';
import _ from 'lodash';

angular.module('application').filter('sclCurrency', ["currentCurrency", "util", function (currentCurrency, util) {
    return function (amount, currencySymbol, fractionSize, symbolFirst) {
        const currency = currentCurrency.currency();

        if (_.isUndefined(currencySymbol)) {
            currencySymbol = currency.symbol_native;
        }

        if (_.isUndefined(fractionSize)) {
            fractionSize = currency.decimal_digits;
        }

        if(_.isNil(amount) || _.isNaN(amount)) {
            amount = 0;
        } else if(!_.isNumber(amount)) {
            amount = _.toNumber(amount);
        }

        var roundedNumber = util.round(amount, fractionSize).toFixed(fractionSize);
        var separatedNumber = roundedNumber.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1###');

        var withDecimalSeparatorNumber = separatedNumber.replace('.', currency.decimal_separator || '.');
        var valueStr = withDecimalSeparatorNumber.replace(/###/g, currency.thousands_separator || '');

        if(!_.isEmpty(currencySymbol)) {
            if(!_.isNil(symbolFirst)) {
                return symbolFirst ? `${currencySymbol} ${valueStr}` : `${valueStr} ${currencySymbol}`;
            } else {
                return currency.symbol_first ? `${currencySymbol} ${valueStr}` : `${valueStr} ${currencySymbol}`;
            }
        }

        return valueStr;
    };
}]);
